import { takeLatest, call, put, select, debounce } from 'redux-saga/effects';
import ANSWER_TYPES from './types';
import notificationActions from '../Notifications/actions';
import sectionActions from '../Sections/actions';
import { sagaWrapper, dateFormat, secureLocalStorage } from 'src/helpers';
import Service from 'src/service';
import { type RootState, history } from 'src/store';
import { ICourse, type ISection } from 'src/models';
import courseActions from '../Courses/actions';

const Answer = new Service('answers');

function* saveEdition({ payload }: any) {
	const section: ISection = yield select((state: RootState) => state.sections.section);

	yield call(Answer.createPath, `?questionId=${payload.questionId}`, payload.answers);
	yield put(notificationActions.add('success', 'Respuestas guardadas'));
	yield put(sectionActions.getOne(section.id || 0));
}

function* saveUserCourseAnswers({ payload }: any) {
	const { userAnswers, courseId, userId } = payload;
	const { startedAt } = yield select((state: RootState) => state.courses.examTracker);
	yield call(
		Answer.createPath,
		`user/course?courseId=${courseId}&userId=${userId}&startedAt=${dateFormat(
			startedAt,
			'time',
		)}&finishedAt=${dateFormat(new Date(), 'time')}`,
		userAnswers,
	);

	// Delete saved exam
	const savedExams: any[] = yield secureLocalStorage.get('ues') || [];
	const examByUserIndex = savedExams.findIndex((value: any) => value.userId == userId);
	if (examByUserIndex > -1) {
		savedExams.splice(examByUserIndex, 1);
		secureLocalStorage.set('ues', savedExams);
	}

	yield put(notificationActions.add('success', 'Examen terminado'));
	yield history.push('/app/courses');
	yield put(courseActions.set('examTracker', { startedAt: '' }));
}

function* saveUserSectionAnswers({ payload }: any) {
	const { userAnswers, sectionId, userId } = payload;
	const {
		course,
		examTracker: { startedAt },
	} = yield select((state: RootState) => state.courses);
	yield call(
		Answer.createPath,
		`user/section?sectionId=${sectionId}&userId=${userId}&startedAt=${dateFormat(
			startedAt,
			'time',
		)}&finishedAt=${dateFormat(new Date(), 'time')}`,
		userAnswers,
	);

	// Delete saved exam
	const savedExams: any[] = yield secureLocalStorage.get('ues') || [];
	const examByUserIndex = savedExams.findIndex((value: any) => value.userId == userId);
	if (examByUserIndex > -1) {
		savedExams.splice(examByUserIndex, 1);
		secureLocalStorage.set('ues', savedExams);
	}

	yield put(notificationActions.add('success', 'Examen terminado'));
	yield history.push(`/app/courses/${course.id}`);
	yield put(courseActions.set('examTracker', { startedAt: '' }));
}

function* updateUserSectionAnswers({ payload }: any) {
	const { userAnswers, sectionId, userId, courseId } = payload;
	yield call(Answer.updatePath, `user/section?sectionId=${sectionId}&userId=${userId}`, userAnswers);
	yield put(notificationActions.add('success', 'Examen actualizado'));
	yield put(courseActions.getExamReview(courseId, userId));
}

export default function* index() {
	yield takeLatest(ANSWER_TYPES.SAVE_EDITION, sagaWrapper(saveEdition));
	yield debounce(2000, ANSWER_TYPES.SAVE_USER_COURSE_ANSWERS, sagaWrapper(saveUserCourseAnswers));
	yield debounce(2000, ANSWER_TYPES.SAVE_USER_SECTION_ANSWERS, sagaWrapper(saveUserSectionAnswers));
	yield debounce(2000, ANSWER_TYPES.UPDATE_USER_SECTION_ANSWERS, sagaWrapper(updateUserSectionAnswers));
}
